import { storyblokEditable } from "@storyblok/react/rsc"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"
import { getRenderedRichText } from "@/components/ui/helpers/richtextRenderer"
import { UbRichTextCardStoryblok } from "@/components/storyblok/component-types"

interface UbRichTextCardProps {
  blok: UbRichTextCardStoryblok
  sbLocale?: string
}

const textAlignmentVariants = cva("", {
  variants: {
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right",
      justify: "text-justify",
    },
  },
  defaultVariants: {
    align: "left",
  },
})

const lineClampVariants = cva("", {
  variants: {
    clamp: {
      none: "line-clamp-none",
      "1": "line-clamp-1",
      "2": "line-clamp-2",
      "3": "line-clamp-3",
      "4": "line-clamp-4",
      "5": "line-clamp-5",
      "6": "line-clamp-6",
    },
  },
  defaultVariants: {
    clamp: "none",
  },
})

// see https://www.npmjs.com/package/storyblok-rich-text-react-renderer
export default function UbRichTextCard({ blok, ...restProps }: UbRichTextCardProps) {
  //const translatableSlugs: SlugTranslations = await fetchStoryblokTranslatableSlugs()
  const align = blok.text_alignment
  const clamp = blok.line_clamp
  const richtext = blok.richtext

  const renderedRichText = getRenderedRichText(richtext, restProps.sbLocale)

  return (
    <div {...storyblokEditable(blok)} className="group relative flex flex-col overflow-hidden">
      <div className="flex flex-1 flex-col space-y-2">
        <div className={cn("text-wrap whitespace-pre-wrap", textAlignmentVariants({ align }), lineClampVariants({ clamp }))}>
          {renderedRichText}
        </div>
      </div>
    </div>
  )
}
